import { UploadDetail } from '../../../../../../services/entities/impl/blfApi/schemas/uploadSummary';
import { useTranslation } from '../../../../../../services/translation/hooks/useTranslation';

export const useUploadStatusLabel = (uploadStatus: UploadDetail['status']) => {
  const { t } = useTranslation();
  return t(STATUS_DISPLAY_MAP[uploadStatus]);
};

const STATUS_DISPLAY_MAP: Record<UploadDetail['status'], string> = {
  Uploading: 'Uploading...',
  'In Progress': 'Generating block details...',
  Completed: 'Complete',
};
